import React from "react";
import { Collapse } from "antd";
import TabelaPadrao from "../../components/TabelaPadrao";
import toLocale from "../../Utils/ToLocaleString";
import { formatarCorPorValorMovimentacao } from "../../Utils/utils";
const { Panel } = Collapse;

export default function CollapseMovimentacao({ dados }) {
  return <Collapse ghost style={{ background: "none" }}>
    {dados?.map((x, inx) =>
      <Panel key={inx} style={{ borderBottom: "1px solid #d9d9d9", padding: 5, borderRadius: 0 }}
        header={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>{x.nome}</span>
            <span>{toLocale(x.valor)}</span>
          </div>}>
        <TabelaPadrao columns={columns} data={x.lista} />
      </Panel>
    )}
  </Collapse>;
}

const columns = [
  {
    Header: "Data/Hora",
    accessor: "data",
    tipo: "dthr",
  },
  {
    Header: "Tipo",
    accessor: "tipo",
  },
  {
    Header: "Número",
    accessor: "numero",
    Cell: props => <span style={{ color: formatarCorPorValorMovimentacao(props.row.original.valor) }}>{props.row.original.numero}</span>,
  },
  {
    Header: "Nota fiscal",
    accessor: "nf"
  },
  {
    Header: "Cliente / Histórico",
    accessor: "historico",
    Cell: props => <span>{!!props.row.original.pessoa ? props.row.original.pessoa : props.row.original.historico}</span>
  },
  {
    Header: "Valor total",
    accessor: "valor",
    Cell: props => <span style={{ color: formatarCorPorValorMovimentacao(props.row.original.valor) }}>{toLocale(props.row.original.valor)}</span>,
    tipo: "right"
  }
];
